"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_APP_LINT_FORBIDDEN_PROPERTIES = exports.CUSTOM_APP_LINT_FORBIDDEN_SELECTORS = exports.CUSTOM_APP_CSS_VARS = exports.CUSTOM_APP_FIELD_TYPE_ATTR = exports.CUSTOM_APP_FIELD_ATTR = exports.CUSTOM_APP_ROLE_ATTR = exports.CUSTOM_APP_STATE_VALUES = exports.CUSTOM_APP_STATE_ATTR = exports.CUSTOM_APP_FLAG_ATTRS = exports.CUSTOM_APP_COMPONENT_ID_VALUES = exports.CUSTOM_APP_COMPONENT_IDS = exports.CUSTOM_APP_SHELL_ROLE_IDS = exports.CUSTOM_APP_COMPONENT_ATTR = exports.CUSTOM_APP_ROOT_ATTRS = exports.CUSTOM_APP_MOTION_INDEX_CSS_VAR = exports.CUSTOM_APP_MOTION_CLASS_PREFIX = exports.CUSTOM_APP_SCOPE_CLASS = void 0;
const custom_app_design_baseline_1 = require("./custom-app-design-baseline");
const motion_css_1 = require("./motion-css");
const view_component_types_1 = require("./view-component-types");
/**
 * sl-8n5m.14.1 / sl-sbpf.1: Stable CSS Contract for Custom Apps.
 *
 * Single Source of Truth for all stable CSS class names, data-attributes,
 * and CSS custom properties exposed to user-authored CSS.
 *
 * Rule: every Custom App component MUST emit attributes/classes listed here.
 *       user-authored CSS MUST only target selectors derived from this file.
 *
 * Drift policy: adding a new entry is additive (no breaking change).
 *               renaming / removing an entry is a public-API break and
 *               requires a version bump + deprecation window.
 */
exports.CUSTOM_APP_SCOPE_CLASS = motion_css_1.DEFAULT_MOTION_SCOPE_CLASS;
exports.CUSTOM_APP_MOTION_CLASS_PREFIX = motion_css_1.MOTION_CLASS_PREFIX;
exports.CUSTOM_APP_MOTION_INDEX_CSS_VAR = motion_css_1.MOTION_INDEX_CSS_VAR;
exports.CUSTOM_APP_ROOT_ATTRS = {
    appId: 'data-sl-app-id',
    appSlug: 'data-sl-app-slug',
    mode: 'data-sl-mode',
};
/**
 * Attribute carrying the component identifier on every rendered
 * component wrapper and shell region: `data-sl-component="…"`.
 */
exports.CUSTOM_APP_COMPONENT_ATTR = 'data-sl-component';
/**
 * Shell-level region identifiers emitted by ShellLayout and the
 * row-detail renderer. These are NOT ViewComponents — they identify
 * layout regions of the published page shell.
 */
exports.CUSTOM_APP_SHELL_ROLE_IDS = {
    shell: 'shell',
    hero: 'hero',
    nav: 'nav',
    search: 'search',
    tags: 'tags',
    pagination: 'pagination',
    form: 'form',
    content: 'content',
    rowDetail: 'row-detail',
    freeComposition: 'free-composition-layer',
};
/**
 * All values emitted on `data-sl-component="…"`.
 *
 * Derived from VIEW_COMPONENT_TYPES: every registered ViewComponent
 * type IS a valid component id — a new component type joins the
 * contract automatically, drift is impossible by construction.
 */
exports.CUSTOM_APP_COMPONENT_IDS = {
    ...exports.CUSTOM_APP_SHELL_ROLE_IDS,
    ...view_component_types_1.VIEW_COMPONENT_TYPES,
};
exports.CUSTOM_APP_COMPONENT_ID_VALUES = Array.from(new Set(Object.values(exports.CUSTOM_APP_COMPONENT_IDS)));
exports.CUSTOM_APP_FLAG_ATTRS = {
    hero: 'data-sl-flag-hero',
    search: 'data-sl-flag-search',
    tags: 'data-sl-flag-tags',
    form: 'data-sl-flag-form',
    nav: 'data-sl-flag-nav',
    pagination: 'data-sl-flag-pagination',
};
exports.CUSTOM_APP_STATE_ATTR = 'data-sl-state';
exports.CUSTOM_APP_STATE_VALUES = {
    loading: 'loading',
    empty: 'empty',
    error: 'error',
    missingBinding: 'missing-binding',
    selected: 'selected',
    hovered: 'hovered',
};
exports.CUSTOM_APP_ROLE_ATTR = 'data-sl-role';
exports.CUSTOM_APP_FIELD_ATTR = 'data-sl-field';
exports.CUSTOM_APP_FIELD_TYPE_ATTR = 'data-sl-field-type';
exports.CUSTOM_APP_CSS_VARS = Object.freeze(Object.keys(custom_app_design_baseline_1.CUSTOM_APP_DESIGN_BASELINE_TOKENS));
exports.CUSTOM_APP_LINT_FORBIDDEN_SELECTORS = ['.affine-', '._'];
exports.CUSTOM_APP_LINT_FORBIDDEN_PROPERTIES = ['!important'];
